import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Tabs } from "../../../common/UIComponents";
import QuoteOrderDetails from "./QuoteOrderDetails";
import OrderQuoteRevisions from "./OrderQuoteRevisions";
import OrderQuoteActivity from "./OrderQuoteActivity";
import OrderFiledActivities from "../../../components/orders/OrderFiledActivities";

function QuoteModelDetails({
  logo,
  quoteId,
  currentQuote,
  revisions,
  quote_activities,
}) {
  const { TabPane } = Tabs;

  const decimalPoints = window.localStorage.getItem("round_off_decimals");
  const zeroValue = Number((0).toFixed(decimalPoints));

 const quoteCharges = currentQuote?.quote?.quotes[currentQuote?.quote.quotes.length -1]

  const renderExpandedRow = (record) => {
    const quotesData = Array.isArray(record?.quotes)
      ? record.quotes.map((rec) => ({ ...rec, id: randomNumber() }))
      : [];
    return quotesData.length > 0 ? (
      <Row>
        <Col span={8} className="padding10">
          <h3>Audit</h3>
          <OrderFiledActivities
            data={quotesData}
            pagination={{ position: "none" }}
          />
        </Col>
      </Row>
    ) : (
      <Row>
        <Text className="textCenter">No Audit Log Found</Text>
      </Row>
    );
  };

  return (
    <div>
      <Tabs>
        <TabPane tab={"Details"} key="Details">
          <QuoteOrderDetails
            quote={currentQuote?.quote || null}
            wh_location_details={currentQuote?.wh_location_details || null}
            orders={currentQuote?.orders?.[0] || null}
            order_items={currentQuote?.order_items?.[0] || null}
            pickup_location_details={
              currentQuote?.pickup_location_details || null
            }
            delivery_location_details={
              currentQuote?.delivery_location_details || null
            }
            appointment={currentQuote?.appointment || null}
            quoteCharges={quoteCharges}
            logo={logo}
            decimalPoints={decimalPoints}
            zeroValue={zeroValue}
          />
        </TabPane>
        <TabPane tab={"Revisions"} key="Revisions">
          <OrderQuoteRevisions
            revisions={revisions}
            expandedRowRender={renderExpandedRow}
            orderType={currentQuote?.type_of_order}
            decimalPoints={decimalPoints}
            zeroValue={zeroValue}
          />
        </TabPane>
        <TabPane tab={"Activity"} key="Activity">
          <OrderQuoteActivity
            quote_activities={quote_activities || []}
            orderType={currentQuote?.type_of_order}
            decimalPoints={decimalPoints}
            zeroValue={zeroValue}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default QuoteModelDetails;
